import React from 'react'
import { withRouter } from 'react-router-dom'
import { Grid } from '@material-ui/core'
import Stats from 'components/TasksPage/DataPanels'
import Tasks from 'components/TasksPage/Tasks'
// import { task } from 'components/routes'
// import ListView from 'components/ListView'

export default withRouter(({ history, match }) => (
  <Grid container spacing={24}>
    <Grid item xs={12}>
      <Stats
        ownedBy={
          match.params.campaignID !== 'new'
            ? { type: 'C', id: match.params.campaignID }
            : null
        }
        half={true}
      />
    </Grid>
    <Grid item xs={12}>
      <Tasks
        ownedBy={{ type: 'C', id: match.params.campaignID }}
        history={history}
        campaignPage
      />
    </Grid>
  </Grid>
))
